/** Shared transport + operation retry policy for GraphQL WebSocket subscriptions. */
export const GRAPHQL_WS_RETRY = {
  keepAliveMs: 30_000,
  initialDelayMs: 1_000,
  maxDelayMs: 30_000,
  maxAttempts: 30,
} as const;

export function graphqlWsRetryDelayMs(
  attempt: number,
  initialMs: number = GRAPHQL_WS_RETRY.initialDelayMs,
  maxMs: number = GRAPHQL_WS_RETRY.maxDelayMs
): number {
  return Math.min(initialMs * 2 ** attempt, maxMs);
}

/** Delay between graphql-ws transport reconnect attempts (`retryWait`). */
export function graphqlWsRetryWait(retries: number): Promise<void> {
  const delayMs = graphqlWsRetryDelayMs(retries);
  return new Promise((resolve) => setTimeout(resolve, delayMs));
}

/**
 * Transport-layer retry filter for graphql-ws `shouldRetry`.
 * Fatal protocol/auth codes are handled by graphql-ws and are not passed here.
 */
export function shouldRetryGraphqlWsTransport(
  errOrCloseEvent: unknown
): boolean {
  if (errOrCloseEvent instanceof CloseEvent) {
    // Abnormal closure (network/proxy drop). Do not retry 1009, 4400, etc.
    return errOrCloseEvent.code === 1006;
  }
  return false;
}

export function logGraphqlSubscriptionEvent(
  scope: string,
  message: string,
  detail?: unknown
): void {
  const prefix = `[GraphQL subscription:${scope}]`;
  if (detail !== undefined) {
    console.warn(prefix, message, detail);
    return;
  }
  console.warn(prefix, message);
}
